export const CHAPTER_VIEW_SUMMARY_CARD_WIDTH = 160

export const CHAPTER_VIEW_SUMMARY_BAR_CONTENT_WIDTH = 80

export const CHAPTER_VIEW_SECTION_CARD_WIDTH = 132

export const CHAPTER_VIEW_ROW_GAP = 8

export const CHAPTER_VIEW_MAX_SECTIONS_PER_ROW = 10

export const CHAPTER_VIEW_FIRST_ROW_SECTION_CAPACITY = 5

export const CHAPTER_VIEW_EXAMPLE_LEGEND_WIDTH = 277

export const CHAPTER_VIEW_ZERO_SCORE_BACKGROUND = '#FAD3D3'

export const CHAPTER_VIEW_ZERO_SCORE_BACKGROUND_OPACITY = 0.28

export const CHAPTER_VIEW_PROGRESS_BAR_HEIGHT = 40

export const CHAPTER_VIEW_PROGRESS_BAR_WIDTH = 14

export const CHAPTER_VIEW_BOOK_BAR_WIDTH = 38

export const CHAPTER_VIEW_CHAPTER_BAR_WIDTH = 26

export const CHAPTER_VIEW_SECTION_BAR_WIDTH = 12

export const CHAPTER_VIEW_SECTION_MARGIN = 8

export const CHAPTER_VIEW_PERCENT_LINE_HEIGHT = 14

export const CHAPTER_VIEW_TITLE_LINE_HEIGHT = 14

export const CHAPTER_VIEW_SUBTITLE_LINE_HEIGHT = 11.5

export const CHAPTER_VIEW_BOOK_TITLE_SLOT_HEIGHT = 24

export const CHAPTER_VIEW_BAR_TOP_OFFSET =
  CHAPTER_VIEW_SECTION_MARGIN +
  CHAPTER_VIEW_PERCENT_LINE_HEIGHT +
  CHAPTER_VIEW_SECTION_MARGIN

